
import { Inject, Injectable } from "@angular/core";
import { AsyncSubject, Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { AuthenticatedMode, AuthenticatedModeContainer } from "../../../app/app.module";
import { ISystemConfiguration } from "../interfaces/interfaces";
import { SystemConfigurationPreLoginService } from "./system.configuration.pre.login.service";
import { SystemConfigurationProxy } from "./system.configuration.proxy";

/**
 ****************************************************************
 * Service class for getting system configuration from server.
 *
 * Written by: Stanislav Korobov
 ****************************************************************
 */
@Injectable({ providedIn: 'root' })
  export class SystemConfigurationService {
	public cachedSysCfg:Map<boolean,ISystemConfiguration>;
	private systemConfigurationReadySubject = new AsyncSubject();

	constructor(private systemConfigurationProxy:SystemConfigurationProxy,
				private preLoginConf:SystemConfigurationPreLoginService,
				@Inject(AuthenticatedMode) private isAuth:AuthenticatedModeContainer ) {
					this.cachedSysCfg=new Map();
				}

	// moved to SystemConfigurationPreLoginService
	// public getPreLoginSystemConfiguration(): Observable<ISystemConfiguration> {
	// 	return this.systemConfigurationProxy.GetPreLoginSystemConfiguration();
	// }

	/**
	 * @deprecated use SystemConfigurationValues instead
	 */
	public getCachedCfg(){
		return this.cachedSysCfg.get(this.isAuth.mode);
	}

	public authenticatedSystemConfigurationReadyObservable(){
		return this.systemConfigurationReadySubject.asObservable();
	}

	public getSystemConfiguration(): Observable<ISystemConfiguration> {
		if (this.isAuth.mode){
			return this.systemConfigurationProxy.GetSystemConfiguration().pipe(map(sysCfg=>{
				this.cachedSysCfg.set(this.isAuth.mode, sysCfg) ;

				this.systemConfigurationReadySubject.next(null);
				this.systemConfigurationReadySubject.complete();

				return sysCfg;
			}));
		}else{
			return this.preLoginConf.getPreLoginSystemConfiguration().pipe(map(sysCfg=>{
				this.cachedSysCfg.set(this.isAuth.mode, sysCfg) ;
				
				// this.systemConfigurationReadySubject.next(null);
				// this.systemConfigurationReadySubject.complete();

				return sysCfg;
			}));
		}

	}
}
